import {BlockSelectorProps} from "./types";
import React from "react";
import SearchSelect from "@ui-components/SearchSelect";
import Alert from "@ui-components/Alert";
import {useIntl} from "react-intl";

export const BlockSelector = ({
  label,
  value,
  options,
  onChange,
  showNotFoundWarning = false,
  editable=true,
  ...rest
}: BlockSelectorProps) => {

  // hooks
  const intl = useIntl();

  // utils
  const disabled =
    showNotFoundWarning
    && !!value
    && !options.some((option) => option.value === value);

  return (
    <div className="flex flex-col">
      {/* @ts-ignore */}
      <SearchSelect
        label={label}
        options={options}
        value={options.find((option) => option.value === value)}
        onChange={onChange}
        isClearable={!disabled}
        isDisabled={disabled || !editable}
        {...rest}
      />
      {disabled && (
        <div className="mb-4">
          {/* @ts-ignore */}
          <Alert
            title={intl.formatMessage({
              id: "empty_expression_selector_info_title",
              defaultMessage: "Perché non vedo il valore selezionato?",
            })}
            text={intl.formatMessage({
              id: "empty_expression_selector_info_text",
              defaultMessage: "Il selettore è vuoto (e disabilitato) perché contiene un riferimento che non è "
                + "presente tra i blocchi disponibili per la versione del configuratore selezionata. Per verificarlo, "
                + "prova a selezionare un'altra versione"
            })}
          />
        </div>
      )}
    </div>
  )
}